import { FunctionComponent } from 'react'
import { Typography, Box } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import { UserRoles } from 'common/types'

interface SignUpMessageProps {
  role: UserRoles
  onLogin: Function
}

export const SignUpMessage: FunctionComponent<SignUpMessageProps> = ({ role, onLogin }) => {
  const theme = useTheme()
  const isSummit = window.location.pathname.includes('summit')

  return (
    <Box
      display="flex"
      flexDirection="column"
      padding='0 5em'
      alignItems="center"
      width="100%"
      mb="0.5em"
    >

      <Typography gutterBottom variant="body1" align="center">
        <Box color={theme.colors.accent1}>
          {isSummit && (
            <Typography variant="body2">
              Ready to do it big at BFUTR 2022? Become a BPTN Member to get your passes!
            </Typography>
          )}
          {!isSummit && role === UserRoles.Member && (
            <Typography variant="body2">
              <strong> Sign up with your socials or email to join Obsidi </strong>
            </Typography>
          )}
          {!isSummit && role === UserRoles.Partner && (
            <Typography variant="body2">
              Sign up with your company credentials
            </Typography>
          )}
        </Box>
      </Typography>
    </Box>
  )
}
